type RewardToastProps = {
  message: string | null;
  tone: 'happy' | 'try' | 'launch';
};

export function RewardToast({ message, tone }: RewardToastProps) {
  if (!message) return null;

  return (
    <div className={`rr-toast rr-toast-${tone}`} role="status" aria-live="polite">
      {message}
    </div>
  );
}
